import React from 'react';
import Gallery from '@browniebroke/gatsby-image-gallery';

import { GatsbyImage } from 'gatsby-plugin-image';
import { Animation } from 'gatsby-theme-portfolio-minimal/src/components/Animation';
import { Section } from 'gatsby-theme-portfolio-minimal/src/components/Section';
import { useLocalDataSource } from './data';
import { PageSection } from 'gatsby-theme-portfolio-minimal/src/types';
import * as classes from './style.module.css';


export function GallerySection(props: PageSection): React.ReactElement {
    const response = useLocalDataSource();

    // display received query for debug
    // console.log('response')
    // console.log(response)

    const images = response.images.edges.map(({node},index) => ({
    thumb:node.childrenImageSharp[0].thumb,
    full:node.childrenImageSharp[0].full,
//    caption: node.name,
    }))
    // display processed query for debug
    // console.log('images')
    // console.log(images)

    // Override some of Lightbox options to localise labels in French
    const lightboxOptions = {
        imageLoadErrorMessage: 'Unable to load image 画像を読み込むことができませんでした',
        nextLabel: 'next',
        prevLabel: 'prev',
        zoomInLabel: 'zoom in',
        zoomOutLabel: 'zoom out',
        closeLabel: 'close',
    }

    //Add callback to Lightbox onCloseRequest
    const onClose = () => {
        console.log('Lightbox was closed')
    }

    return (
        <Animation type="fadeUp">
            <Section anchor={props.sectionId} heading={props.heading} additionalClasses={[classes.Gallery]}>
                <Gallery
                    images={images}
                    lightboxOptions={lightboxOptions}
                    onClose={onClose}
                />
            </Section>
        </Animation>
    );
}
